import { render, staticRenderFns } from "./AccountHistory.vue?vue&type=template&id=cb84d366&scoped=true&"
import script from "./AccountHistory.vue?vue&type=script&lang=js&"
export * from "./AccountHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb84d366",
  null
  
)

export default component.exports